// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"5f6a5afd","775":"0e247763"}[chunkId] + ".chunk.css";
};